export default __webpack_public_path__ + "34e91f7.png";